export async function downloadFile(file, name) {
  const response = await fetch(file)
  if (!response.ok) {
    throw new Error(response.status)
  }

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  link.click()
  URL.revokeObjectURL(url)
}
